import { Upload, Dropdown } from "antd";
import { PlusOutlined, LoadingOutlined } from "@ant-design/icons";

export default function UploadButton({
    onUpload,
    uploading,
}: {
    onUpload: (file: File) => void;
    uploading?: boolean;
}) {
    const items = [
        {
            key: "folder",
            label: (
                <Upload
                    directory
                    showUploadList={false}
                    beforeUpload={(file) => {
                        onUpload(file);
                        return false;
                    }}
                >
                    <div className="px-3 py-2 text-000000e0">Tải lên thư mục</div>
                </Upload>
            ),
        },
        {
            key: "file",
            label: (
                <Upload
                    multiple
                    showUploadList={false}
                    beforeUpload={(file) => {
                        onUpload(file);
                        return false;
                    }}
                >
                    <div className="px-3 py-2 text-000000e0">Thêm ảnh</div>
                </Upload>
            ),
        },
    ];

    return (
        <Dropdown menu={{ items }} trigger={["click"]} disabled={uploading}>
            <button
                disabled={uploading}
                className="flex items-center gap-2 px-3 py-2 bg-[#3e91ab] text-white rounded-lg hover:opacity-90 disabled:opacity-60"
            >
                {uploading ? <LoadingOutlined /> : <PlusOutlined />}
                Thêm ảnh
            </button>
        </Dropdown>
    );
}